/**
 * An empty `<p>`, e.g. "<p>      </p>"
 */
const trimmedRTFRegex = /<p>\s*<\/p>/;

/**
 * @param rtfText output from a rich text field.
 * @returns A string with whitespace and empty `<p>` tags trimmed.
 */
export function trimRTF(rtfText: string) {
  const trimmedString = rtfText.trim();
  return trimmedString.replace(trimmedRTFRegex, "");
}

// Importing from here rather than test file since importing from a test file runs all the tests in that file
// https://stackoverflow.com/q/69457249
export const emptyRTFTestCases = ["<p>     </p>", "  ", ""] as const;

/**
 * When the user deletes an RTF field, this can leave empty `<p>` tags, e.g. `<p></p>`.
 *
 * @param rtfText output from a rich text field.
 * @returns whether the RTF is empty, including empty `<p>` tags.
 */
export function isEmptyRTF(rtfText: string): boolean {
  return !trimRTF(rtfText);
}
